import React from "react";
import TestsPageTemplate from "../components/TestsPageTemplate";
import {TEST_TYPES} from "../../../../shared/types/testTypes";

const TestsCustom = () => {

    return (
        <TestsPageTemplate
            config={TEST_TYPES.customTest}
        />
    );
}

export default TestsCustom;